import { Order } from '../types/order';
import { CreateOrderInput, DeleteOrderInput, UpdateOrderInput } from '../types/order/order.input';
import { ProductTransaction, ProductTransactionSpecifiers } from '../types/productTransaction';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const GET = '/api/order';
const LIST = '/api/order/list';

const CREATE = '/api/order/create';
const UPDATE = '/api/order/update';
const DELETE = '/api/order/delete';

const COMPLETE = '/api/order/complete';
const CANCEL = '/api/order/cancel';

const IDS = '/api/order/ids';

const ADD_PRODUCTS = '/api/order/add/product';

const PROCESS = '/api/order/process';

export namespace OrderRequest {
  export const get = async (id: string): Promise<Order> => {
    return (await http.get(`${GET}/${id}`)).data;
  };

  export const ids = async (payload: { ids: string[]; page: number }): Promise<PaginatedResponse<Order>> => {
    return (await http.post(IDS, payload)).data;
  };

  export const list = async (payload: { page: number }): Promise<PaginatedResponse<Order>> => {
    return (await http.post(LIST, payload)).data;
  };

  export const create = async (payload: { data: CreateOrderInput[] }): Promise<Order[]> => {
    return (await http.post(CREATE, payload)).data;
  };

  export const update = async (payload: { data: UpdateOrderInput[] }): Promise<Order[]> => {
    return (await http.post(UPDATE, payload)).data;
  };

  export const remove = async (payload: { data: DeleteOrderInput[] }): Promise<Order[]> => {
    return (await http.post(DELETE, payload)).data;
  };

  export const complete = async (payload: { id: string }): Promise<Order> => {
    return (await http.post(COMPLETE, payload)).data;
  };

  export const cancel = async (payload: { id: string }): Promise<Order> => {
    return (await http.post(CANCEL, payload)).data;
  };

  export const process = async (payload: { id: string; statusId: string }): Promise<Order> => {
    return (await http.post(PROCESS, payload)).data;
  };

  export const addProducts = async (payload: {
    id: string;
    specifiers: ProductTransactionSpecifiers[];
  }): Promise<ProductTransaction[]> => {
    return (await http.post(ADD_PRODUCTS, payload)).data;
  };
}
